var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalculadoras(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calculadoras",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M0,0H25V25H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68746",
    "data-name": "Group 68746",
    transform: "translate(-18.203 -97.203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28484",
    "data-name": "Rectangle 28484",
    width: 21,
    height: 21,
    transform: "translate(20.203 99.203)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "calculate_FILL0_wght400_GRAD0_opsz24",
    d: "M125.146-824.563h1.544v-2.058h2.058v-1.544H126.69v-2.058h-1.544v2.058h-2.058v1.544h2.058Zm5.146-.772h5.146v-1.544h-5.146Zm0-2.573h5.146v-1.544h-5.146Zm1.132-3.911,1.441-1.441,1.441,1.441,1.081-1.081-1.441-1.492,1.441-1.441-1.081-1.081-1.441,1.441-1.441-1.441-1.081,1.081,1.441,1.441-1.441,1.492Zm-8.079-1.8h5.146v-1.544h-5.146Zm-1.286,12.144a1.982,1.982,0,0,1-1.454-.6,1.982,1.982,0,0,1-.6-1.454v-14.408a1.982,1.982,0,0,1,.6-1.454,1.982,1.982,0,0,1,1.454-.6h14.408a1.982,1.982,0,0,1,1.454.6,1.982,1.982,0,0,1,.6,1.454v14.408a1.982,1.982,0,0,1-.6,1.454,1.982,1.982,0,0,1-1.454.6Zm0-2.058h14.408v-14.408H122.058Zm0-14.408v0Z",
    transform: "translate(-98.287 940.712)",
    fill: "#0e426a"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculadoras);
export default __webpack_public_path__ + "static/media/calculadoras.74817de54b1292a2c62bc9ac053351d5.svg";
export { ForwardRef as ReactComponent };